module.exports = __webpack_public_path__ + "img/Primordial-Process-5-mobile.9461ee5d.png";